import React from "react";
import HomePageHero from "./HomePageHero";
import LogoSliderV2 from "components/common/LogoSliderV2";
import PlatformSection from "./PlatformSection";
import ProductsSection from "./ProductsSection";
import CustomerStoriesSection from "./CustomerStoriesSection";
import ReviewBlade from "./ReviewBlade";
import CTABannerHome from "components/common/footer-banners/CTABannerHome";
import VideoTabber from "./VideoTabber";

const HomePage = () => {
  return (
    <>
      <HomePageHero />
      <LogoSliderV2 />
      <PlatformSection />
      <ProductsSection />
      <VideoTabber />
      <ReviewBlade />
      <CustomerStoriesSection />
      <CTABannerHome />
    </>
  );
};

export default HomePage;
